export class Pagination {
    pageSize;
    totalPages;
    pageNumber;
    callback;
    numberOfElements;
    totalElements;

    constructor(obj) {
        this.pageSize = obj && obj.pageSize || DefaultPagination.pageSize;
        this.totalPages = obj && obj.totalPages || DefaultPagination.totalPages;
        this.pageNumber = obj && obj.pageNumber || DefaultPagination.pageNumber;
        this.callback = obj && obj.callback || DefaultPagination.callback;
        this.numberOfElements = obj && obj.numberOfElements || DefaultPagination.numberOfElements;
        this.totalElements = obj && obj.totalElements || DefaultPagination.pageSize;
    }

    static createPagination(obj) {
        return new Pagination(obj);
    }
}

export const DefaultPagination = {
    pageSize: 50,
    totalPages: 1,
    pageNumber: 0,
    firstPage: 0,
    callback: (() => {}),
    numberOfElements: 0
};


// WEBPACK FOOTER //
// ./src/store/modules/page/Pagination.js